// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36wYL","input":"styles_input__24Z38"};